import { makeGenericToken } from './util.make-generic-token.js';

/**
 * represents a token that translates to a CSS length (e.g. a number + a unit)
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/length
 */
function makeLengthToken(propName, input) {
  return makeGenericToken(function format(value) {
    return `calc(${value} * var(${propName}, ${input}))`;
  }, function override(nextValue) {
    if (nextValue === undefined) {
      return {};
    }
    return {
      [propName]: typeof nextValue === "function" ? nextValue() : String(nextValue)
    };
  }, function extend(extendedPropName) {
    return makeLengthToken(extendedPropName, `var(${propName}, ${input})`);
  }, {
    propName
  });
}

export { makeLengthToken };
//# sourceMappingURL=token.length.js.map
